import { NgModule } from '@angular/core';
import { ModPreloginService } from './services/modprelogin-service.service';
import { MarketNewsComponent } from './components/MarketNews/market-news.component';
import { MarketUpdateComponent } from './components/MarketUpdate/market-update.component';
import { MarketCalenderComponent } from './components/MarketCalender/market-calender.component';
import { LoginMarketingComponent } from './components/LoginMarketing/login-marketing.component';
import { MarketIndicesComponent } from './components/MarketIndices/market-indices.component';
import { MarketIndicesDialogueComponent } from './components/MarketIndices/market-indices-dialogue.compoenet';
import { QuickQuoteComponent } from './components/QuickQuote/quick-quote.component';
import { QuickQuoteService } from './services/quickquote-service.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NguCarouselModule } from '@ngu/carousel';
//import { ContentManagementModule } from '@pershing/nxi-contentmanagement';
import { NxiNgCommonModule } from '@pershing/nxi-ng-common';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyOptionModule as MatOptionModule } from '@angular/material/legacy-core';
import { MatDividerModule } from '@angular/material/divider';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MarketAlertsAgreementComponent } from './components/MarketAlertsAgreement/market-alerts-agreement.component';
import { MarketAlertsWrapperComponent } from './components/MarketAlertsWrapper/market-alerts-wrapper.component';
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { SymbolService } from './services//symbol.service';
import { OverviewHoldingsService } from './services/overview-holdings.services';
import {
  PershingCoreRootModule,
  PershingTranslationService,
} from '@pershing/pershing-core';
import { PershingCommonModule } from '@pershing/pershing-common';
import { ModernQuickQuoteComponent } from './components/ModernQuickQuote/modern-quick-quote.component';
import { QuickQuoteCardComponent } from './components/QuickQuoteDialog/quick-quote-dialog.component';
import { QuickQuoteFormInputComponent } from './components/QuickQuoteSearch/quick-quote-search.component';
import { QuoteToggleModule } from '@pershing/nxi-ng-quotetoggle';
export const PRELOGIN_MOD_COMPONENTS = [
  QuickQuoteComponent,
  ModernQuickQuoteComponent,
  MarketNewsComponent,
  MarketUpdateComponent,
  MarketCalenderComponent,
  LoginMarketingComponent,
  MarketIndicesComponent,
  MarketIndicesDialogueComponent,
  MarketAlertsAgreementComponent,
  MarketAlertsWrapperComponent,
];

export const PRELOGIN_MOD_PROVIDERS = [
  QuickQuoteService,
  ModPreloginService,
  OverviewHoldingsService,
  SymbolService,
  PershingTranslationService,
];

@NgModule({
  imports: [
    // This will be moved to app specific
    // common module and appsepcific common module will be
    // imported here
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    HttpClientModule,
    HttpClientJsonpModule,
    MatDividerModule,
    NguCarouselModule,
    //ContentManagementModule,
    NxiNgCommonModule,
    MatIconModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatSelectModule,
    MatOptionModule,
    MatMenuModule,
    MatTooltipModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    PershingCoreRootModule,
    PershingCommonModule,
    QuoteToggleModule,
  ],
  declarations: [
    ...PRELOGIN_MOD_COMPONENTS,
    QuickQuoteCardComponent,
    QuickQuoteFormInputComponent,
  ],
  exports: [...PRELOGIN_MOD_COMPONENTS],
  providers: [...PRELOGIN_MOD_PROVIDERS],
})
export class ModPreloginModule {}
